import { isMonth, isYear } from "./date";
import { tryParseInt } from "./common";

export const parseCard = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const reCardTrack1 = /%b(\d+?)\^(.+?)\/(.+?)\^(\d{2})(\d{2})(?=\d)/i;

  const matches = value!.match(reCardTrack1);
  if (!Array.isArray(matches)) {
    return undefined;
  }

  let [
    ,
    cardNumber = undefined,
    lastName = undefined,
    firstMiddleName = undefined,
    expirationYear = undefined,
    expirationMonth = undefined,
  ] = matches;

  return {
    cardNumber,
    lastName,
    firstMiddleName,
    expirationMonth,
    expirationYear,
  };
};

export const isCardNumber = (
  value?: string,
  cardNumberLength?: number | number[]
) => {
  if (!value || !cardNumberLength) {
    return false;
  }

  const cardNumberLengths = Array.isArray(cardNumberLength)
    ? cardNumberLength
    : [cardNumberLength];

  let isMatch = false;

  for (let i = 0, l = cardNumberLengths.length; i < l; ++i) {
    const cardNumberLength = cardNumberLengths[i];
    const reCardNumber = new RegExp(`^\\d{${cardNumberLength}}$`);

    if (reCardNumber.test(value)) {
      isMatch = true;
      break;
    }
  }

  return isMatch;
};

export const toCardData = (
  cardNumber?: string,
  expirationMonth?: string,
  expirationYear?: string,
  firstMiddleName?: string,
  lastName?: string
) => ({
  cardNumber: cardNumber,
  ...(isYear(expirationYear) &&
    isMonth(expirationMonth) && {
      expiration: `${expirationMonth}${expirationYear}`,
    }),
  ...(isMonth(expirationMonth) && {
    expirationMonth: expirationMonth,
  }),
  ...(isYear(expirationYear) && {
    expirationYear: expirationYear,
  }),
  ...(!!firstMiddleName &&
    !!lastName && {
      cardHolder: `${firstMiddleName.trim()} ${lastName.trim()}`,
    }),
  ...(!!firstMiddleName && {
    cardHolderFirstMiddleName: firstMiddleName.trim(),
  }),
  ...(!!lastName && { cardHolderLastName: lastName.trim() }),
});

export const getCardExpirationPart = (
  expiration: string,
  indexStart: number,
  indexEnd?: number
) => (!!expiration ? expiration.substring(indexStart, indexEnd) : undefined);

export const getCardExpirationMonth = (expiration: string) =>
  getCardExpirationPart(expiration, 0, 2);

export const getCardExpirationYear = (expiration: string) =>
  getCardExpirationPart(expiration, 2);

export const parsePaymentSystemError = (error?: string) => {
  if (!error) {
    return undefined;
  }

  const parts = error.split("&");
  if (!Array.isArray(parts) || !parts.length) {
    return undefined;
  }

  const result = {};

  for (let i = 0, l = parts.length; i < l; ++i) {
    const part = parts[i];
    if (!part || !part.length) {
      continue;
    }

    const pair = part.split("=");
    if (!Array.isArray(pair) || pair.length < 2 || !pair[0]) {
      continue;
    }

    (result as { [key: string]: any })[pair[0]] = pair[1];
  }

  return Object.keys(result).length ? result : undefined;
};

export const checkCardData = (
  cardNumber?: string,
  expirationMonth?: string,
  expirationYear?: string,
  cardNumberLength?: number | number[]
) => {
  const month = tryParseInt(expirationMonth as string);
  const year = tryParseInt(expirationYear as string);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  return (
    (isCardNumber(cardNumber as string, 16) || isCardNumber(cardNumber as string, 15)) &&
    !isNaN(month) &&
    month >= 1 &&
    month <= 12 &&
    !isNaN(year) &&
    (2000 + year > currentYear ||
      (2000 + year === currentYear && month >= currentMonth))
  );
};
